import { Navigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../auth/auth-context";
import { AppRoutes } from "../app/routes";
import "./role-home.css";

/**
 * The app root ("/"). Dispatches an authenticated user to their role's area:
 * ambassador → daily route, supervisor → backoffice (day summary). Admin
 * and operations still land on a placeholder until their screens are built
 * (D-5 / E0.3). Keeping this separate from each area is what stops a role
 * mismatch from redirect-looping.
 */
export const RoleHome = () => {
  const { t } = useTranslation("shell");
  const { user } = useAuth();

  switch (user?.role) {
    case "ambassador":
      return <Navigate to={AppRoutes.AMBASSADOR_ROUTE} replace />;
    case "supervisor":
      return <Navigate to={AppRoutes.SUPERVISOR_SUMMARY} replace />;
    case "admin":
      return <Navigate to={AppRoutes.ADMIN_USERS} replace />;
    case "operations":
      return <Navigate to={AppRoutes.OPERATIONS_BATCHES} replace />;
    case "contact_center":
      return <Navigate to={AppRoutes.PENDING_CONFIRMATION} replace />;
    case "compliance":
      return <Navigate to={AppRoutes.COMPLIANCE_CUSTOMERS} replace />;
    case null:
    case undefined:
      return <Navigate to={AppRoutes.PENDING} replace />;
    default:
      return (
        <div className="role-home">
          <div className="role-home-frame">
            <h1 className="role-home-title">{t("backoffice_soon_title")}</h1>
            <p className="role-home-body">{t("backoffice_soon_body")}</p>
          </div>
        </div>
      );
  }
};
